import SuiBox from '@upheal/design-system/components/legacy/Sui/SuiBox';
import { SxProps } from '@mui/material';

type Props = { sx?: SxProps };

const Line = (props: Props) => {
    const { sx } = props;
    return (
        <SuiBox
            width="100%"
            height="1px"
            bgColor="lightNew"
            flexShrink={0}
            sx={sx}
        />
    );
};

export default Line;
